import { render } from "./GridBoard.vue?vue&type=template&id=4c3ab69a&scoped=true"
import script from "./GridBoard.vue?vue&type=script&lang=js"
export * from "./GridBoard.vue?vue&type=script&lang=js"

import "./GridBoard.vue?vue&type=style&index=0&id=4c3ab69a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c3ab69a"]])

export default __exports__